import { NitteCalendarEvent, Period } from '@WombatTechnology/nitte-time-lib'
import { parseISO } from 'date-fns'
interface PeriodResponse {
  start: string
  end: string
}

export type EventResponse = Omit<NitteCalendarEvent, 'period'> & {
  period: PeriodResponse
}

const parsePeriodResponse = (p: PeriodResponse): Period | Period[] => {
  // NOTE: ここで勝手にUTCをブラウザの時間に変更してくれてるので一旦これで。
  // タイムゾーンに対応する場合ここの対応が必要になる。
  const start = parseISO(p.start)
  const end = parseISO(p.end)

  return new Period(start, end)
}

export const parseEventResponse = (
  event: EventResponse
): NitteCalendarEvent => {
  const {
    id,
    title,
    isAllDay,
    period,
    htmlLink,
    onlineMeetingURL,
    hasSchedule,
    responseStatus
  } = event
  return {
    id,
    title,
    period: parsePeriodResponse(period) as Period,
    isAllDay,
    onlineMeetingURL,
    htmlLink,
    hasSchedule,
    responseStatus
  }
}
